import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { loadAccountFeature, loadAccountFeaturesFinished } from './account.actions';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { UserAccountService } from '../../../services/user-account.service';
import { FeatureToggleService } from '../../../services/feature-toggle.service';
import { LoggerService } from '../../../services';

@Injectable()
export class AccountFeatureEffects {
    private readonly actions$ = inject(Actions);
    private readonly userAccountService = inject(UserAccountService);
    private readonly featureToggleService = inject(FeatureToggleService);
    private readonly logger = inject(LoggerService);

    loadAccountFeatures$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadAccountFeature),
            switchMap(({ customerId }) =>
                this.userAccountService.getUserAssignFeatures(customerId).pipe(
                    map(accountFeatures => {
                        this.featureToggleService.setAccountFeature(accountFeatures.featureUserAccounts);
                        return loadAccountFeaturesFinished({ accountFeatures });
                    }),
                    catchError((error: unknown) => {
                        // Fail CLOSED (ADO-114494): deny every Account.* gate and keep the UI recoverable.
                        this.featureToggleService.setAccountFeature({});
                        this.logger.logError(error, 'AccountFeatures:LoadFailed', true);
                        return of(
                            loadAccountFeaturesFinished({
                                accountFeatures: { email: '', organizationId: 0, featureUserAccounts: {} }
                            })
                        );
                    })
                )
            )
        )
    );
}
